
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import { useResults } from "@/hooks/useResults";
import { LoadingResults } from "@/components/results/LoadingResults";
import { ImagePreview } from "@/components/results/ImagePreview";
import { IdeasList } from "@/components/results/IdeasList";

export default function ResultsPage() {
  const { resultId } = useParams<{ resultId: string }>();
  const navigate = useNavigate();
  const { loading, ideas, image, handleSaveIdea } = useResults(resultId);
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/30">
      <Header />
      
      <main className="container max-w-4xl mx-auto pt-20 pb-16 px-4">
        <div className="text-center mb-8">
          <Button
            variant="ghost"
            size="sm"
            className="absolute left-4 top-20 sm:left-8"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
          
          <h1 className="text-3xl font-bold font-display mt-6">Creative Ideas</h1>
          <p className="text-muted-foreground mt-2 max-w-md mx-auto">
            Here are some creative activities based on your objects
          </p>
        </div>
        
        {loading ? (
          <LoadingResults />
        ) : (
          <div className="grid grid-cols-1 gap-6">
            <ImagePreview image={image} />
            <IdeasList ideas={ideas} onSaveIdea={handleSaveIdea} />
          </div>
        )}
      </main>
    </div>
  );
}
